var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTooltip = function SvgTooltip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 26 26"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#76BF43",
    fillRule: "evenodd",
    d: "M25.44 12.72a12.72 12.72 0 1 1-25.44 0 12.72 12.72 0 0 1 25.44 0ZM13.99 7.63a1.27 1.27 0 1 1-2.54 0 1.27 1.27 0 0 1 2.54 0Zm-1.27 2.55c-.7 0-1.27.57-1.27 1.27v6.36a1.27 1.27 0 1 0 2.54 0v-6.36c0-.7-.57-1.27-1.27-1.27Z",
    clipRule: "evenodd"
  })));
};
export default SvgTooltip;